import { ArrowLeft } from "@gravity-ui/icons";
import { Button, Icon, TextInput } from "@gravity-ui/uikit";
import { BuyerOrderFilterType } from "definitions/poizon-api";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { VirtualMultiSelect } from "src/components/VirtualMultiSelect/VirtualMultiSelect";
import { RoutesPaths } from "src/routes/RoutesPaths";

import { PoizonFilterFormProps } from "../../store/atoms/poizonFilterAtom";
import {
  OrderFilterStatus,
  OrderFilterStatusOptions,
} from "../../widgets/PoizonOrderFilterWidget/PoizonOrderList.contants";
import css from "./PoizonOrderFilter.module.scss";

interface PoizonOrderFilterProps {
  onChange: (newValue: PoizonFilterFormProps) => void;
  defaultValue: PoizonFilterFormProps;
}

export const PoizonOrderFilter = ({
  onChange,
  defaultValue,
}: PoizonOrderFilterProps) => {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState<string | undefined>(
    defaultValue.keyword,
  );
  const [type, setType] = useState(defaultValue.type);

  const handleTypeChange = (next: BuyerOrderFilterType) => {
    setType(next);
    onChange({ type: next, keyword });
  };

  const handleKeywordChange = (next: string) => {
    setKeyword(next);
    onChange({ type, keyword: next });
  };

  return (
    <div>
      <div className={css.contContainer}>
        <div>
          <Button
            view="flat"
            size="m"
            style={{ fontWeight: "bold" }}
            onClick={() => navigate(RoutesPaths.LK.PROFILE.BASE_PATH)}
          >
            <Icon data={ArrowLeft} />
            Назад
          </Button>
        </div>

        <div style={{ maxWidth: "180px" }}>
          <VirtualMultiSelect<BuyerOrderFilterType>
            options={OrderFilterStatusOptions}
            value={type}
            onChange={(v) => handleTypeChange(v ?? OrderFilterStatus.ALL)}
          />
        </div>
      </div>
      <div className={css.searchContainer}>
        <TextInput
          placeholder="Поиск"
          size="l"
          value={keyword}
          onChange={(e) => handleKeywordChange(e.target.value)}
        />
      </div>
    </div>
  );
};
